import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";

import { Stage, Layer, Image } from "react-konva";
import { useDataset } from "../../Api/newSockets.api";
import PolygonAnnotation from "./PolygonAnnotation";
import useCheckMobileScreen from "../../hooks/useCheckScreen";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import AnnotationImage from "./AnnotationImage";
import AnnotationToolbox from "./AnnotationToolbox";
import AnnotationImageList from "./AnnotationImageList";
import Modal from "../Modals/Modal";
import PrimaryButton from "../Buttons/PrimaryButton";
import OutlinedButton from "../Buttons/OutlinedButton";
const videoSource = "./cat.jpg";

type Props = {
  images: any;
  imageIndex?: any;
  onAddAnnotation: any;
};

const AnnotationTool = ({ images, imageIndex, onAddAnnotation}: Props) => {

  const [activeImageIndex, setActiveImageIndex] = useState(imageIndex);
  const [activeTool, setActiveTool] = useState("select");
  const [annotations, setAnnotations] = useState<any>(images[imageIndex]?.fileAnnotations[0]?.annotations);
  const [activeAnnotationId, setActiveAnnotationId] = useState<any>();
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [scale, setScale] = useState(1);
  const [stageDraggable, setStageDraggable] = useState(true);


  // useEffect(() => {
  //   setActiveImageIndex(imageIndex);
  //   setAnnotations(images[imageIndex]?.fileAnnotations[0]?.annotations || []);
  // }, [imageIndex]);
  // useEffect(() => {
  //   setImages(props.images);
  // }, [props.images]);

  // const updateAnnotation = (image) => {
  //   console.log("updating image Annotation, new image: ", image)
  //   setActivePoints(image.fileAnnotations[0]?.annotations[0]?.points || [])
  //   setActiveFlattenedPoints(image.fileAnnotations[0]?.annotations[0]?.flattenedPoints || [])
  //   setPosition([0, 0])
  //   setActivePolyComplete(image.fileAnnotations?.length > 0 ? true : false)
  //   console.log("new image data:", isActivePolyComplete, image.fileAnnotations[0]?.annotations[0]?.points, activePoints, image.fileAnnotations[0]?.annotations[0]?.flattenedPoints, activeFlattenedPoints)
  // }

  // const onAnnotationsChange = (index, annotations) => {
  //   {
  //     props.onAddAnnotation(index, annotations);
  //   }
  //   updateAnnotation(props.images[index]);
  //   setImageIndex(index);
  // };
  const saveAnnotations = () => {
    onAddAnnotation(activeImageIndex, annotations);
  };
  const onImageChange = (index) => {
    console.log("onImageChange", activeImageIndex, annotations)
    if(annotations != images[activeImageIndex]?.fileAnnotations[0]?.annotations) {
      // setSaveModalOpen(true);
      console.log("Saving annotations", annotations, images[activeImageIndex]?.fileAnnotations[0]?.annotations)
      onAddAnnotation(activeImageIndex, annotations);
    }
    // if (isActivePolyComplete && images[imageIndex].fileAnnotations[0]?.annotations[0]?.points != activePoints) {
    //   props.onAddAnnotation(imgIndex, activePoints, activeFlattenedPoints);
    // }
    // updateAnnotation(props.images[index]);
    setAnnotations(images[index]?.fileAnnotations[0]?.annotations);
    setActiveAnnotationId(null);
    
    setActiveImageIndex(index);
    setActiveTool("select");
  };

  const onToolChange = (tool) => {	
    setActiveTool(tool);

    switch (tool) {
      case "select":
        setStageDraggable(true);
        break;
      case "polygon":
        setStageDraggable(false);
        break;
      case "rectangle":
        setStageDraggable(false);
        break;
      case "zoomin":
        setScale(scale + 0.5);
        break;
      case "zoomout": 
        setScale(scale - 0.5);
        break;
      default:
        break;

    }
    // if(tool == "polygon") {
    //   console.log("Tool changed to polygon")
    //   setAnnotations([...annotations, {id: annotations.length, type: "polygon", points: [], flattenPoints: []} ])
    // }
    // setActiveAnnotation(null);
    // setActivePoints([]);
    // setActivePolyComplete(false);
  };

  // const onAnnotationsChange = (annotations) => {
  //   setAnnotations(annotations);
  // }
  const onActiveAnnotationIdChange = (id) => {
    console.log("onActiveAnnotationIdChange", id)
    setActiveAnnotationId(id);
  };

  const onAnnotationDelete = (id) => {
    console.log("onAnnotationDelete", id)
    setAnnotations(annotations.filter((a) => a.id !== id));
  };
  const onClose = () => {
    setSaveModalOpen(false);
  };
  var footer = (
    <>
      <PrimaryButton onSubmit={saveAnnotations}>Save</PrimaryButton>
      <OutlinedButton onClick={()=>setSaveModalOpen(false)}>Discard</OutlinedButton>
    </>
  );

  return (
    <div className="annotation">
      <Fragment>
        <div className="annotation-header">
          <h3 className="title">{images[activeImageIndex]?.fileName}</h3>
        </div>
        <div className="annotation-body">
          <AnnotationToolbox
            activeTool={activeTool}
            onToolChange={onToolChange}
          />
          <Modal
              visible={saveModalOpen}
              onClose={onClose}
              footer={footer}
              title={`You have unfinished work. Do you want to save annotations on this image?`}
              subtitle="Warning: you will lose all unsaved data"
              desc="By clicking 'Save' you will save all annotations on this image. By clicking 'Discard' you will lose all unsaved data."
            />
          <AnnotationImage 
            activeImage={images[activeImageIndex]}
            activeTool={activeTool}
            // onAnnotationChange={onAnnotationsChange}
            onToolChange={onToolChange}
            scale={scale}
            annotations={annotations}
            setAnnotations={setAnnotations}
            stageDraggable={stageDraggable}
            onActiveAnnotationIdChange={onActiveAnnotationIdChange}
            activeAnnotationId={activeAnnotationId}
          />
          <AnnotationImageList
            images={images}
            imageIndex={activeImageIndex}
            onImageChange={onImageChange}
            annotations={annotations}
            activeAnnotationId={activeAnnotationId}
            onActiveAnnotationIdChange={onActiveAnnotationIdChange}
            onAnnotationDelete={onAnnotationDelete} 
          />
        </div>
      </Fragment>
    </div>
  );
};

export default AnnotationTool;
